import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BaseModalMixin } from '~/mixins';
import CHANGELOG from '../../../CHANGELOG.md';
let ModalChangeLog = class ModalChangeLog extends BaseModalMixin {
};
ModalChangeLog = __decorate([
    Component({
        components: {
            CHANGELOG
        }
    })
], ModalChangeLog);
export default ModalChangeLog;
